import(/* webpackMode: "eager" */ "/cf-demo/app/global-error.tsx")